import {type ReactNode} from 'react';
import {Users} from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@kroll-resolver-crisp/ui-components-react';
import {type Item} from '@/api/items';
import {cn} from '@/lib/utils';

// A video's channel name, clickable: the menu offers to classify that channel without leaving
// the video list.
export function ChannelMenu({
  item,
  className,
  onClassifyChannel,
  children
}: {
  readonly item: Item;
  readonly className?: string;
  readonly onClassifyChannel: (item: Item) => void;
  readonly children: ReactNode;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`Channel actions for ${String(children)}`}
        className={cn(
          'hover:text-foreground cursor-pointer underline-offset-2 hover:underline',
          className
        )}
        onClick={(event) => {
          event.stopPropagation();
        }}>
        {children}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem
          onClick={(event) => {
            event.stopPropagation();
            onClassifyChannel(item);
          }}>
          <Users />
          Classify channel
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
